export default "__VITE_ASSET__ZYHvdI_P__"